import React, { useState } from "react";
import s from "./Cards.module.scss";
import { Statistic } from "antd";
import { ArrowUpOutlined } from "@ant-design/icons";
import SelectField from "../../../../../../global components/Forms/SelectField/SelectField";
import { formatNumber } from "../../../../../../libs/api/userSession";
import { ArrowDownFilled } from "../../../../../../global components/Icons/ArrowDownFilled";
type cardType = "users" | "msgSent" | "";

type CardProp = {
  type?: cardType;
  handleStat?: ({ type, value }: { type: cardType; value: string }) => void;
  cardTitle: string;
  cardStat: number;
  growthInPercentage?: number | undefined;
  filters?: string | false;
};

function Card({
  filters,
  cardStat,
  cardTitle,
  type,
  handleStat,
  growthInPercentage,
}: CardProp) {
  const [filter, setFilter] = useState<string>("7");
  function handleFilter(value: string) {
    setFilter(value);
    handleStat && type && handleStat({ type, value });
  }
  return (
    <div className={s.wrapper}>
      <h5 className={s.label}>{cardTitle}</h5>
      <span className={s.numbers}>
        <h6 className={s.stat}>{formatNumber(cardStat)}</h6>
        {type && (
          <span className={s.stats}>
            <Statistic
              //title="Active"
              value={growthInPercentage}
              precision={2}
              valueStyle={{
                color: growthInPercentage?.toString().includes("-")
                  ? "red"
                  : "#1EB564",
              }}
              prefix={
                growthInPercentage?.toString().includes("-") ? (
                  <ArrowDownFilled className={s.downIcon} />
                ) : (
                  <ArrowUpOutlined className={s.upIcon} />
                )
              }
              suffix="%"
              rootClassName={s.percentage}
              style={{ fontSize: "12px", fontWeight: 400 }}
            />
            <SelectField
              bordered
              suffixIcon={<></>}
              rootClassName={s.select}
              wrapperClassname={s.SelectWrapper}
              defaultValue={"7"}
              value={filters || filter}
              onChange={(value: any) => handleFilter(value)}
              style={{
                fontSize: "10px",
                maxHeight: "16px",
                color: "#6A6767",
              }}
              options={[
                { value: "7", label: "This week" },
                { value: "31", label: "This month" },
                { value: "365", label: "This year" },
              ]}
            />
          </span>
        )}
      </span>
    </div>
  );
}

export default Card;
